import React, { FunctionComponent, useState } from 'react'
import { InjectedIntlProps, injectIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'

import { LoadingContent } from 'src/components/loading-content/LoadingContent'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'

import {
  DESCRIPTION_ID,
  LOCATION_ID,
  ATTRACTIONS_ID,
  HOST_ID,
  PHOTOS_ID,
  DATE_AND_TIME_ID,
  DATE_DISPLAY_OPTIONS,
} from './constants'
/* eslint-disable css-modules/no-unused-class */
import locale from './locale'
import attractionsLocale from './AttractionsSection/locale'

const style = require('./eventNavigation.css')

const Placeholder = ({ menuItems }) => menuItems && (
  <LoadingPlaceholder modifierClass={style.placeholder}>
    {menuItems.map(item => <LoadingContent key={item.name} width="80px" height="12px" />)}
  </LoadingPlaceholder>
)

interface Props {
  eventData: any,
  loading: Boolean,
  isSticky: Boolean,
  navHeight: number,
}

const MenuComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  loading,
  isSticky,
  navHeight,
  intl: { formatMessage },
}) => {
  const [activeMenuItem, setActiveMenuItem] = useState('')

  const menuItems = [
    {
      name: DESCRIPTION_ID,
      displayed: !!(eventData && eventData.description),
      buttonText: formatMessage(locale.description),
    },
    {
      name: DATE_AND_TIME_ID,
      displayed: !!(eventData &&
        !eventData.hiddenDate &&
        eventData.dateDisplayOption !== DATE_DISPLAY_OPTIONS.hideEventTime &&
        eventData.totalTimeSlotCount &&
        eventData.totalTimeSlotCount > 0),
      buttonText: formatMessage(locale.dateAndTime),
    },
    {
      name: LOCATION_ID,
      displayed: !!(eventData && eventData.address && !eventData.virtual),
      buttonText: formatMessage(locale.location),
    },
    {
      name: ATTRACTIONS_ID,
      displayed: !isEmpty(eventData?.attractions),
      buttonText: formatMessage(attractionsLocale.attractions),
    },
    {
      name: HOST_ID,
      displayed: !!(eventData && eventData.user),
      buttonText: formatMessage(locale.host),
    },
    {
      name: PHOTOS_ID,
      displayed: !!(eventData && eventData.allImages.length),
      buttonText: formatMessage(locale.photos, { numPhotos: '' }),
    },
  ]

  const scrollToSection = (e) => {
    const itemName = e.target.dataset.name

    setActiveMenuItem(itemName)

    const scrollTarget = document.getElementById(itemName)
    const SCROLL_OFFSET = 80

    window.scrollTo({
      left: 0,
      top: scrollTarget.offsetTop - (isSticky ? SCROLL_OFFSET : SCROLL_OFFSET + navHeight),
      behavior: 'smooth',
    })
  }

  const getMenuItemClass = itemName => (
    activeMenuItem === itemName
      ? `${style.menuItem} ${style.menuItemActive}`
      : style.menuItem
  )

  if (loading) {
    return <Placeholder menuItems={menuItems} />
  }

  return (
    <ul className={style.menu}>
      {
        menuItems.map(item => item.displayed && (
          <button
            key={item.name}
            data-name={item.name}
            onClick={scrollToSection}
            className={getMenuItemClass(item.name)}
          >
            {item.buttonText}
          </button>
        ))
      }
    </ul>
  )
}

export const Menu = injectIntl(MenuComponent)
